import { Button } from '@mui/material'
import React, { MouseEventHandler } from 'react'
import { MessageIcon } from '../../../../common/icons/MessageIcon'
import { DoctorPatientProfile } from '../types/doctorPatients.types'
import { useTranslation } from '../../../../common/hooks'
import { useHistory } from 'react-router-dom'

interface SendMessageToPatientButtonProps {
  patientProfile: DoctorPatientProfile
}

export const SendMessageToPatientButton: React.FC<
  SendMessageToPatientButtonProps
> = ({ patientProfile }) => {
  const { t } = useTranslation()
  const history = useHistory()

  const email = patientProfile.user?.email
  const chatUserId = patientProfile.user?.id

  const handleMessageClick: MouseEventHandler = (event) => {
    if (!chatUserId) {
      return
    }
    event.preventDefault()
    history.push(`/messages/${chatUserId}`)
  }

  return (
    <Button
      startIcon={<MessageIcon />}
      color="primary"
      size="large"
      disabled={!email?.length && !chatUserId?.length}
      onClick={handleMessageClick}
      href={email ? `mailto:${email}` : undefined}
      sx={{ width: 'fit-content' }}
    >
      {t('patients:actions.message')}
    </Button>
  )
}
